import { render, staticRenderFns } from "./ProductRecommend.vue?vue&type=template&id=a47f5346&scoped=true"
import script from "./ProductRecommend.vue?vue&type=script&lang=js"
export * from "./ProductRecommend.vue?vue&type=script&lang=js"
import style0 from "./ProductRecommend.vue?vue&type=style&index=0&id=a47f5346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47f5346",
  null
  
)

export default component.exports